// function changeSize(cloudinaryUrl, width = 200, height = 200) {
//   const resizedUrl = cloudinaryUrl.replace(
//     "/upload/",
//     `/upload/c_fit,h_${height},w_${width}/`
//   )
//   return resizedUrl
// }


function changeSize(cloudinaryUrl, width = 200, height = 200) {
  return cloudinaryUrl.replace(
    /\/upload\/(v\d+\/)?/, // Сохраняем версию (если есть)
    `/upload/c_fit,h_${height},w_${width}/$1`
  );
}

 
 export default changeSize